import React, { useEffect, useState } from 'react';
import ReactTable from "react-table";
import { Modal } from 'react-bootstrap';
import i18next from "i18next";

import { PageTitle } from "../PageTitle";
import { TimeFormattingService, AuditService, ThresholdsService } from '../../services';

const AuditThresholdEntryDiffModal = ({show, toggle, changeEntity}) => {
    const [beforeThreshold, setBeforeThreshold] = useState(null);
    const [afterThreshold, setAfterThreshold] = useState(null);

    useEffect(() => {
        if (changeEntity) {
            console.log(changeEntity)
            ThresholdsService.get(changeEntity.beforeId).then(threshold => {
                setBeforeThreshold(threshold);
            }).catch(error => {
                console.error(error);
                // TODO handle
            });
            ThresholdsService.get(changeEntity.afterId).then(threshold => {
                setAfterThreshold(threshold);
            }).catch(error => {
                console.error(error);
                // TODO handle
            });
        }
    }, [changeEntity]);

    return (
        <Modal show={show} onHide={toggle}>
            <Modal.Header closeButton>
                <Modal.Title>Threshold Changes</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    beforeThreshold && afterThreshold ?
                        <div>TODO {changeEntity.beforeId} vs {changeEntity.afterId}</div>
                        :
                        null
                }
            </Modal.Body>
        </Modal>
    );
};

const Audits = () => {
    const [searchResults, setSearchResults] = useState([]);
    const [searching, setSearching] = useState(false);
    const [searchConfig, setSearchConfig] = useState({});
    const [showThresholdModal, setShowThresholdModal] = useState(false);
    const [currentChangeEntity, setCurrentChangeEntity] = useState(null);

    useEffect(() => {
        if (searchConfig.startTimestamp > 0 && searchConfig.endTimestamp > 0 && searchConfig.startTimestamp < searchConfig.endTimestamp) {
            var queryConfig = [];
            Object.keys(searchConfig).forEach((key) => {
                if(searchConfig[key] != null) {
                    var entry = {};
                    entry[key] = searchConfig[key];
                    queryConfig.push(entry);
                }
            });
            AuditService.findAuditEntries(queryConfig).then(({changeEvents}) => {
                setSearchResults(changeEvents);
                setSearching(false);
            }).catch((error) => {
                console.error(error);
                setSearching(false);
            });    
        } else {
            setSearching(false);
        }
    }, [searchConfig]);

    const gogo = () => {
        setSearching(true);
        setSearchConfig({
            startTimestamp: 1671370030702,
            endTimestamp: 1671449230832
        });
    };

    const renderNormalTime = (data) => {
        const date = TimeFormattingService.renderDate(data, null);
        const time = TimeFormattingService.renderTime(data, null);
        return (<span>{date} {time}</span>);
    };

    return (
        <div className="admin-devices">
            <div className="row">
                <PageTitle title="Audit Logs" />
            </div>
            <div className="inner op-content-box">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card-block">
                            TODO date range 
                            <button className="btn btn-sm btn-default" onClick={() => gogo()}>Test</button>
                            <br/>

                            <div className="react-table-custom">            
                                <ReactTable
                                    className="-striped -highlight"
                                    data={searchResults}
                                    loading={searching}
                                    showPaginationTop                               
                                    columns={[{
                                        Header: "Change Type",
                                        accessor: "entityToken",
                                        Cell: cell => i18next.t(`audit-change-types.${cell.original.entityToken}`),
                                        minResizeWidth: 100,
                                        width: 300,
                                        sortable: false,
                                        filterable: false
                                    }, {
                                        Header: "Changed At",
                                        accessor: "changedAt",
                                        Cell: cell => renderNormalTime(cell.original.changedAt),
                                        minResizeWidth: 100,
                                        width: 200,
                                        sortable: false,
                                        filterable: false
                                    }, {
                                        Header: "Changed By",
                                        accessor: "changedBy",
                                        Cell: cell => cell.original.changedBy ? `${cell.original.changedBy.firstName} ${cell.original.changedBy.lastName}` : 'System',
                                        minResizeWidth: 100,
                                        width: 300,
                                        sortable: false,
                                        filterable: false
                                    }, {
                                        Cell: cell => <button className="btn btn-sm btn-default" onClick={() => {setCurrentChangeEntity(cell.original); setShowThresholdModal(true);}}>View Changes</button>,
                                        minResizeWidth: 150,
                                        sortable: false,
                                        filterable: false
                                    }]}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AuditThresholdEntryDiffModal show={showThresholdModal} toggle={() => setShowThresholdModal(false)} changeEntity={currentChangeEntity} />
        </div>
    );
};

export default Audits;